import { FC, useMemo } from 'react';
import { Button, Spin, Table } from 'antd';
import { useModal } from '@ebay/nice-modal-react';

import { InventoryStatus, PackageInventoryItem } from '../../queries/api/types';
import InventoryDetailsDrawer from '../inventoryHistory/InventoryDetailsDrawer';
import { GroupedInventory, useGroupedInventories } from '../inventoryHistory/useGroupedInventories';

import '../inventoryHistory/InventoryHistory.less';

const InventairesAValider: FC = () => {
    const inventoryDetailsDrawer = useModal(InventoryDetailsDrawer);
    const { loading, groupedInventories, packageLabelById, packageCodeById, refetch } =
        useGroupedInventories('submission');

    const columns = useMemo(
        () => [
            { title: 'Date', dataIndex: 'date', key: 'date' },
            { title: 'Magasin', dataIndex: 'storeName', key: 'storeName' },
            { title: 'Utilisateur', dataIndex: 'storeUserName', key: 'storeUserName' },
            {
                title: 'Nb emballages inventoriés',
                dataIndex: 'packagesInventory',
                key: 'count',
                render: (items: PackageInventoryItem[]) => items?.length ?? 0,
            },
            {
                title: 'Nb lignes à traiter',
                dataIndex: 'packagesInventory',
                key: 'pending',
                render: (items: PackageInventoryItem[]) =>
                    (items ?? []).filter((i) => i.status === InventoryStatus.notVerified).length,
            },
            {
                title: 'Actions',
                key: 'action',
                render: (_: unknown, record: GroupedInventory) => (
                    <Button
                        size="small"
                        type="primary"
                        onClick={() => {
                            inventoryDetailsDrawer.show({
                                data: {
                                    date: record.rawDate,
                                    storeName: record.storeName,
                                    storeUserName: record.storeUserName,
                                    packagesInventory: record.packagesInventory,
                                    packageLabelById,
                                    packageCodeById,
                                },
                                validationMode: true,
                                onStatusChanged: refetch,
                            });
                        }}
                    >
                        Traiter
                    </Button>
                ),
            },
        ],
        [inventoryDetailsDrawer, packageLabelById, packageCodeById, refetch]
    );

    return (
        <div className="inventory-history-page">
            <h1>Inventaires à valider</h1>

            {loading ? (
                <div className="inventory-history-loading">
                    <Spin />
                </div>
            ) : (
                <Table columns={columns} dataSource={groupedInventories} rowKey="key" pagination={{ pageSize: 20 }} />
            )}
        </div>
    );
};

export default InventairesAValider;
